<template>
  <general-item format="slider">
    <span slot="title">{{ $t('edit.sidebar.in_a_slider') }}</span>
    <span slot="description">{{ $t('edit.sidebar.one_screen_apper_right') }}</span>
  </general-item>
</template>

<script>
import GeneralItem from './GeneralItem';

export default {
  components: {
    GeneralItem,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Slider.vue?ca5aa31a
 **/